import {
  SearchPaymentLinkPaymentsResponse,
  CursorSearch,
} from './src/paymentlinks-payments-v1-payment-link-payment-payment-link-payments.universal';

export * from './src/paymentlinks-payments-v1-payment-link-payment-payment-link-payments.universal.js';

/** @hidden */
export type PaymentLinkPaymentSearch = {};

/**
 * Retrieves a list of up to 100 payment links, given the specified filtering, search expression, sorting, and cursor paging ([SDK](https://dev.wix.com/docs/sdk/articles/work-with-the-sdk/api-query-language) | [REST](https://dev.wix.com/api/rest/getting-started/api-query-language)).
 * @param search - Search options.
 * @public
 * @requiredField search
 * @permissionId PAYMENT_LINK_PAYMENTS.PAYMENT_LINK_PAYMENT_READ
 * @applicableIdentity APP
 * @fqn wix.paymentlinks.payments.v1.PaymentLinkPayments.SearchPaymentLinkPayments
 */
export declare function searchPaymentLinkPayments(
  search: CursorSearch
): Promise<SearchPaymentLinkPaymentsResponse>;
